export default "__VITE_ASSET__DdDUHnrc__"